<ng-progress
  class="progress-bar progress-bar-success"
  id="myProgress"
  #progressBar
  color="#68d6f0"
  min="0"
  speed="200"
  max="100"
  trickleSpeed="300"
  ease="easeInCubic"
  [spinner]="true"
  role="progressbar"
  aria-label="Page loading progress"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="progressBar?.value || 0"
  aria-live="polite"
/>

<router-outlet />
